/* Shared GSAP fade + scroll behavior for drinks/supplements layouts. */
window.initPageAnimations = function () {
  if (typeof gsap === "undefined" || typeof ScrollTrigger === "undefined") {
    console.warn("GSAP / ScrollTrigger not loaded.");
    return;
  }

  if (typeof ScrollSmoother !== "undefined") {
    gsap.registerPlugin(ScrollTrigger, ScrollSmoother);
  } else {
    gsap.registerPlugin(ScrollTrigger);
  }
  ScrollTrigger.config({ ignoreMobileResize: true });
  ScrollTrigger.defaults({
    invalidateOnRefresh: false,
    anticipatePin: 1
  });

  var isTouch = ScrollTrigger.isTouch;
  var mm = gsap.matchMedia();

  var smoother = null;
  if (!isTouch && typeof ScrollSmoother !== "undefined") {
    smoother = ScrollSmoother.create({
      smooth: 1.2,
      effects: true
    });
  }

  var grouped = new Set();

  // Grouped rows: stagger children together
  gsap.utils.toArray(".fade-group").forEach(function (row) {
    var items = gsap.utils.toArray(row.querySelectorAll(".fade-in"));
    if (!items.length) return;

    items.forEach(function (el) {
      grouped.add(el);
    });

    gsap.fromTo(
      items,
      { autoAlpha: 0, y: 24 },
      {
        autoAlpha: 1,
        y: 0,
        duration: 1,
        ease: "power2.out",
        stagger: {
          each: 0.25,
          onComplete: function () {
            var el = this.targets()[0];
            if (el) el.classList.add("fade-in-complete");
          }
        },
        scrollTrigger: {
          trigger: row,
          start: "top 80%"
          // once: true
        }
      }
    );
  });

  // Ungrouped fade-ins: individual triggers
  gsap.utils.toArray(".fade-in").forEach(function (el) {
    if (grouped.has(el)) return;

    gsap.fromTo(
      el,
      { autoAlpha: 0, y: 24 },
      {
        autoAlpha: 1,
        y: 0,
        duration: 1,
        ease: "power2.out",
        scrollTrigger: {
          trigger: el,
          start: "top 80%",
          once: true
        },
        onComplete: function () {
          el.classList.add("fade-in-complete");
        }
      }
    );
  });
};

(function () {
  var ticking = false;

  window.addEventListener("scroll", function () {
    if (!ticking) {
      window.requestAnimationFrame(function () {
        var threshold = window.innerHeight * 0.05;
        var scrolled = window.scrollY > threshold;
        document.documentElement.classList.toggle("scrolled-down", scrolled);
        ticking = false;
      });
      ticking = true;
    }
  });
})();
